import { createMachine } from 'xstate'
import { extractAllStates } from '@/composition/useXState'
import type { Typegen0 } from './PmMultipleResourceAllocationsDeleteState.typegen'
import {
  assertFriendlyError,
  type FriendlyError,
} from '@/functional/friendlyErrors'

export type State = Typegen0['matchesStates']

export const PmMultipleResourceAllocationsDeleteState = createMachine({
  tsTypes:
    {} as import('./PmMultipleResourceAllocationsDeleteState.typegen').Typegen0,
  schema: {
    events: {} as { type: 'CONFIRM' },

    context: {} as {
      error: FriendlyError | undefined
    },
  },

  id: 'PmMultipleResourceAllocationsDeleteState',
  initial: 'askForConfirmation',

  context: {
    error: undefined,
  },

  states: {
    askForConfirmation: {
      on: {
        CONFIRM: 'delete',
      },
    },
    delete: {
      initial: 'deleting',

      states: {
        deleting: {
          invoke: {
            id: 'deleteResourceAllocationsi',
            src: 'deleteResourceAllocations',
            onError: {
              target: 'failed',
              actions: (context, error) => {
                assertFriendlyError(error.data)
                context.error = error.data.errors
              },
            },
            onDone: 'success',
          },
        },

        success: {
          type: 'final',
        },

        failed: {},
      },
    },
  },
})

export const states = extractAllStates(PmMultipleResourceAllocationsDeleteState)
